<template>
  <div>
    <!-- 날짜 -->
    <div class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(115px + 3rem)">
      <div v-if="isPrint" class="flex items-center justify-center gap-3">
        <p class="print-input">{{ form.headerDate | moment("YYYY") }}</p>
        년
        <p class="print-input">{{ form.headerDate | moment("M") }}</p>
        월
        <p class="print-input">{{ form.headerDate | moment("D") }}</p>
        일
      </div>
      <date-selector v-else class="inline-block" v-model="form.headerDate" @change="loadList" :readonly="board.readonly" />
    </div>

    <vs-button ref="loadBtn" color="secondary" type="border" @click="showLoadRiskPost = true">위험성평가 정보 불러오기</vs-button>
    <p style="font-size: 16px; line-height: 17px" class="mb-5">※ [<b>위험성평가</b>(유해·위험요인 파악) → <b>위험성평가회의</b>(위험성평가의 공유) → <b>교육·TBM 전파</b>(위험성 결정, 감소대책 수립) → <b>이행확인</b>(감소대책 실행)]</p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="{ ...board, readonly: true }" :is-print="isPrint" :propTypesTitle="{ com_name: '부서(업체)명' }" />

    <!-- 위험성평가 정보 -->
    <div>
      <h5 class="mt-6"><i class="dot"></i> 위험성평가 정보</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else readonly v-model="form.inputA_1" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <date-selector v-else readonly v-model="form.inputA_2" />
        </div>
        <div>
          <div>관리기간</div>
          <p v-if="isPrint" class="print-input">{{ `${form.inputA_3}~${form.inputA_4}` }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputA_3" readonly />
            ~
            <date-selector v-model="form.inputA_4" readonly />
          </div>
        </div>
        <div>
          <div>예정공정표 첨부</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputA_5.fileName }}
          </p>
          <file-uploader v-else readonly v-model="form.inputA_5" class="w-full flex-1" />
        </div>
        <div class="writeGridLineItem">
          <div>예정공정 현황</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputA_6 }}</p>
          <ml-textarea
            v-else
            readonly
            v-model="form.inputA_6"
            height="90px"
            placeholder="지하2층, 지상 15층 주상복합 신축현장, 작성일 현재 공정률 약 40%이며, 5월 한 달간 지상 8층~10층 구조물 공사, 지하1층 ∼ 지상 3층 내외부 마감공사가 진행 예정임"
          />
        </div>
      </div>
    </div>

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" readonly />

    <!-- ⑨ 일일TBM 활동 현황 -->
    <TMBTable :readonly="!this.form.stdInfo.field_name || !this.form.headerDate || board.readonly" :selectOption="tmbOption" v-model="form.tmbList" class="mb-6" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- Post 불러오기 팝업 -->
    <PopupLoadPrevBoard title="위험성평가 정보 불러오기" :setBoardId="475" v-model="showLoadRiskPost" @selectRowData="loadRiskPost" />
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import RiskTable from "../475/RiskTable.vue";
import TMBTable from "./TMBTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    RiskTable,
    TMBTable,
    DateSelector,
    FileUploader,
    PopupLoadPrevBoard,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      headerDate: { required },
      stdInfo: {
        field_name: { required },
      },
    },
  },

  data() {
    return {
      showLoadRiskPost: false,
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskList: [],
        tmbList: [],
        todayTmb: 0,

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",
      },
      tmbOption: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    headerDate() {
      return moment(this.form.headerDate).format("YYYY-MM-DD");
    },
    postTMBList() {
      const _postList = this.$store.state.board.postListInfo.data;
      if (!!_postList) return _postList.map((post) => this.getContent(post).tmbList);
      else return [];
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        value.todayTmb = value.tmbList.reduce((acc, cur) => acc + Number(cur.input3), 0);
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    const buttonContainer = document.querySelector("#right-button-container");
    const loadBtn = this.$refs.loadBtn;
    buttonContainer.prepend(loadBtn.$el);
  },
  methods: {
    loadRiskPost(data) {
      this.form.headerDate = data.headerDate;
      this.form.stdInfo = data.stdInfo;
      this.form.riskList = data.riskList;

      this.form.inputA_1 = data.inputA_1;
      this.form.inputA_2 = data.inputA_2;
      this.form.inputA_3 = data.inputA_3;
      this.form.inputA_4 = data.inputA_4;
      this.form.inputA_5 = data.inputA_5;
      this.form.inputA_6 = data.inputA_6;

      this.loadList();
    },
    // 내용불러오기
    async loadList() {
      if (!this.form.stdInfo.field_name || !this.form.headerDate) return;

      this.form.tmbList = [];

      const projectId = this.projectId;
      const boardId = this.boardId;
      const page = 1;
      const perPage = 10000;
      const dateTarget = "content$body.headerDate";

      const dateBegin = `${moment(this.headerDate).format("YYYY")}-01-01`;
      const dateEnd = moment(this.headerDate).subtract(1, "days").format("YYYY-MM-DD");
      const keyword = [`content$body.stdInfo.field_name*${this.form.stdInfo.field_name}`];

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        keyword,
        dateTarget,
        dateBegin,
        dateEnd,
      });

      this.oldDataSetting();
    },
    oldDataSetting() {
      if (0 < this.postTMBList.length) {
        const _option = [];
        this.postTMBList.map((_tmb) => {
          _tmb.map((item) => {
            const _dataIndex = _option.findIndex((e) => e.type === item.input1_1);
            if (_dataIndex === -1) _option.push({ type: item.input1_1, value: Number(item.input3) });
            else _option[_dataIndex].value += Number(item.input3);
          });
        });
        this.tmbOption = _option;
      } else {
        this.tmbOption = [];
      }
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.headerDate.required) return "날짜는 반드시 선택해야 합니다";
        if (!this.$v.form.stdInfo.field_name.required) return "위험성평가 정보는 반드시 불러와야 합니다";
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
